import { render } from "./registerUser.vue?vue&type=template&id=5991eac0&scoped=true"
import script from "./registerUser.vue?vue&type=script&lang=js"
export * from "./registerUser.vue?vue&type=script&lang=js"

import "./registerUser.vue?vue&type=style&index=0&id=5991eac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5991eac0"]])

export default __exports__